export default [
    {
        path: '/404',
        meta: { public: true, },
        name: 'NotFound',
        component: () => import('@/views/NotFound.vue')
    },
    {
        path: '/403',
        meta: { public: true, },
        name: 'NotFound',
        component: () => import('@/views/Deny.vue')
    },
    {
        path: '/500',
        meta: { public: true, },
        name: 'NotFound',
        component: () => import('@/views/Error.vue')
    },
    {
        path: '/',
        name: 'trang-chu',
        meta: { requiresAuth: false, roleId: 1, title: 'Trang chủ',},
        component: () => import('@/views/Home.vue')
    },
    {
        path: '/hang-vo-chu',
        name: 'hang-vo-chu',
        meta: { requiresAuth: false, roleId: 1, title: 'Hàng vô chủ',},
        component: () => import('@/views/NoName.vue')
    }
]